module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Sucesso!","description":"As alterações foram salvas com sucesso."},"en-US":{"title":"Success!","description":"The changes have been successfully saved."}}')
  delete Component.options._Ctor
}
